import { FunctionComponent } from 'react';
import { Autocomplete, TextField } from '@mui/material';

export interface SelectOption {
  id: number;
  name: string;
}

interface GenericSelectProps {
  label: string;
  value?: number;
  options: SelectOption[];
  onChange: (value: number | undefined) => void;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}

export const GenericSelect: FunctionComponent<GenericSelectProps> = ({
  label,
  value,
  options,
  onChange,
  helperText,
  error,
  disabled,
  autoFocus,
}) => {
  // Find the selected option object
  const selectedOption = options.find((option) => option.id === value) || null;

  const handleChange = (_event: React.SyntheticEvent, newValue: SelectOption | null) => {
    onChange(newValue ? newValue.id : undefined);
  };

  return (
    <Autocomplete
      value={selectedOption}
      onChange={handleChange}
      options={options}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label={label} error={error} helperText={helperText} autoFocus={autoFocus} InputLabelProps={{ shrink: true }} />
      )}
    />
  );
};
